


























import {
  computed,
  defineComponent,
  toRefs,
  useStore,
  watch
} from '@nuxtjs/composition-api'
import { formFieldProps } from '~/constants/form'
import { useClassifiedForm } from '~/compositions/form'
import { CLASSIFIED_FORM_NS } from '~/store/modules/shared/classifieds/form/state'
import { useElectricField } from '~/compositions/form/electric'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import { useDep } from '~/compositions/dependency-container'

export default defineComponent({
  props: formFieldProps,
  components: { FieldError },
  setup(props) {
    const { name, specs } = toRefs(props)
    const store = useStore()

    const {
      isValid,
      value,
      error,
      suggestions,
      createDatalistElementId,
      debouncedValueChanged
    } = useClassifiedForm(props)

    const { wattToBhp } = useElectricField()
    const formValidationBuilder = useDep(FormValidationBuilder)
    const fuelTypeIsElectric = computed(
      () => store.getters[`${CLASSIFIED_FORM_NS}/fuelTypeIsElectric`]
    )

    const getValueAsWatt = (value: number) => {
      const unit = specs.value?.unit || 'watt'
      if (unit === 'watt') {
        return value
      }

      return value * 1000
    }

    const validateInput = (text: string) => {
      const textAsNum = Number(text)
      formValidationBuilder
        .new(error)
        .required(specs.value?.required, textAsNum)
        .aboveMinNumber(specs.value?.min, textAsNum)
        .belowMaxNumber(specs.value?.max, textAsNum)
        .validate()
    }

    watch(value, val => {
      if (process.client) {
        validateInput(val)
      }
    })

    const handleInput = (text: string) => {
      changeValues(text)
    }

    function changeValues(value: number) {
      debouncedValueChanged(name.value, value)

      if (fuelTypeIsElectric.value) {
        let bhp = wattToBhp(getValueAsWatt(value))
        // Do not allow less than one bhp values
        if (bhp < 1) {
          bhp = 1
        }

        debouncedValueChanged('engine_power', bhp)
      }
    }

    const suggestionsListId = createDatalistElementId(name)
    return {
      isValid,
      value,
      handleInput,
      error,
      suggestionsListId,
      suggestions
    }
  }
})
